import { render, staticRenderFns } from "./ApprovalProcessModule.vue?vue&type=template&id=5e5b395e&scoped=true"
import script from "./ApprovalProcessModule.vue?vue&type=script&lang=js"
export * from "./ApprovalProcessModule.vue?vue&type=script&lang=js"
import style0 from "./ApprovalProcessModule.vue?vue&type=style&index=0&id=5e5b395e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5b395e",
  null
  
)

export default component.exports